import { useCallback, useEffect, useState } from "react";
import { Loader2, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "../../lib/api";
import { formatDateTime } from "../../lib/format";

const LABELS = [["nuevos", "Nuevos archivados"], ["reubicados", "Reubicados"], ["actualizados", "Actualizados"], ["eliminados", "Quitados (ya no están en Drive)"],
  ["por_clasificar", "A Por clasificar"], ["ya_existia", "Ya existían"], ["omitidos", "Omitidos"], ["sin_cambios", "Sin cambios"]];

export const DriveSync = ({ onFinished, mode }) => {
  const [job, setJob] = useState(null);
  const running = job?.status === "en_curso";
  const load = useCallback(() => api.get("/drive/sync/current").then((r) => setJob(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    if (!running) return undefined;
    const t = setTimeout(async () => {
      const j = (await api.get("/drive/sync/current").catch(() => ({ data: job }))).data;
      setJob(j);
      if (j?.status !== "en_curso") onFinished?.();
    }, 2000);
    return () => clearTimeout(t);
  }, [job, running, onFinished]);

  const start = async () => {
    try { setJob((await api.post("/drive/sync")).data); } catch (e) { toast.error(errorMessage(e, "No se pudo sincronizar")); }
  };

  return (
    <div className="space-y-2 border-t border-[#e8edf5] pt-3" data-testid="drive-sync">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="text-xs text-[#5b667a]">Se sincroniza sola {mode === "oauth" ? "cada hora" : "cada 3 horas"}. Lo que agregues, muevas o borres en Drive se refleja aquí.</p>
        <button type="button" onClick={start} disabled={running} className="tr-btn-primary px-3 py-1.5 text-sm" data-testid="drive-sync-now">
          {running ? <Loader2 className="h-4 w-4 animate-spin" /> : <RefreshCw className="h-4 w-4" />} Sincronizar ahora
        </button>
      </div>
      {running && <p className="flex items-center gap-2 text-sm font-semibold" data-testid="drive-sync-progress"><Loader2 className="h-4 w-4 animate-spin text-[#0f5ef7]" />{job.step} · {job.processed.toLocaleString("es-MX")} de {job.files.toLocaleString("es-MX")} archivos</p>}
      {job?.status === "error" || job?.status === "interrumpido" ? <p className="text-sm font-semibold text-[#b42318]" data-testid="drive-sync-error">{job.message}</p> : null}
      {job?.status === "terminado" && (
        <div data-testid="drive-sync-summary">
          <p className="mb-1 text-xs text-[#5b667a]">Última sincronización ({job.trigger}) {formatDateTime(job.finished_at)} · {job.files.toLocaleString("es-MX")} archivos en Drive</p>
          <div className="flex flex-wrap gap-2">
            {LABELS.filter(([k]) => job.counts[k]).map(([k, label]) => (
              <span key={k} className="rounded-full bg-[#f5f8fd] px-2.5 py-1 text-xs font-semibold" data-testid={`drive-sync-count-${k}`}><b className="font-mono">{job.counts[k].toLocaleString("es-MX")}</b> {label}</span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
